export default __webpack_public_path__ + "static/media/icon_ar.1ea19455.svg";